export default "__VITE_ASSET__zxX7YIYd__"